import { NodeResult, NodeResults } from "@custom-types/modelRun"
import { ThresholdFormValues } from "@features/results/Result/ThresholdChartContainer/ThresholdForm"
import { getNodeRunsTimesteps } from "utils/run"

export const getDefaultFormValues = (
  nodesResults: NodeResults,
  lag: number = 0,
  defaultGivenEventNodeLabel?: string,
  defaultEventNodeLabel?: string,
): ThresholdFormValues | undefined => {
  const nodeResultsArray = Object.values(nodesResults)

  if (nodeResultsArray.length < 2) return

  let givenEventResults = nodeResultsArray[0]
  let eventResults = nodeResultsArray[1]

  if (defaultGivenEventNodeLabel) {
    givenEventResults = nodesResults[defaultGivenEventNodeLabel] ?? nodeResultsArray[0]
  }

  if (defaultEventNodeLabel) {
    eventResults = nodesResults[defaultEventNodeLabel] ?? nodeResultsArray[1]
  }

  return {
    given_event: {
      // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
      node: givenEventResults[lag].node_key,
      // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
      timestep: String(givenEventResults[lag].timestep),
      operator: ">",
      // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
      boundary: givenEventResults[lag].data[0] ?? 0,
    },
    event: {
      // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
      node: eventResults[lag].node_key,
      // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
      timestep: String(eventResults[lag].timestep),
      operator: ">",
      // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
      boundary: eventResults[lag].data[0] ?? 0,
    },
  }
}

export const getTimestepMinMaxValues = (timestep: string, results?: NodeResult[]) => {
  if (!timestep || !results) {
    return { min: 0, max: 0 }
  }

  const possibleValues = results.find((item) => String(item.timestep) === timestep)?.data ?? []

  return { min: Math.min(...possibleValues), max: Math.max(...possibleValues) }
}

export const getTimestepOptions = (results?: NodeResult[], lag?: number) => {
  if (!results) {
    return []
  }

  return getNodeRunsTimesteps([results], lag)
}

export const getHighestPrecision = (values: number[]) => {
  const fractionLengths = values.map((value) => String(value).split(".")?.[1]?.length ?? 0)

  return Math.max(...fractionLengths)
}

export const getStepByPrecision = (precision: number) => {
  if (precision < 1) return 1

  // "step" attribute won't work properely for lower than 1e-12
  const maxSupportedPrecision = 12

  const zeros = Array(Math.min(precision, maxSupportedPrecision) - 1)
    .fill("0")
    .join("")

  return Number(`0.${zeros}1`)
}
